import React, { useContext } from 'react';
import { Route } from 'react-router-dom';
import SectionNav from '../organiserDashboard/SectionNav';
import TeamMembers from './TeamMembers';
import AppContext from '../app/AppContext';
import ErrorBoundary from '../helpers/errorBoundary';
import UnpublishedOrgBanner from '../helpers/unpublishedOrgBanner';

export default function Team () {
    const appContext = useContext(AppContext);

    return (
        <div className={`section-container ${!appContext.menuOpen && 'section-container-main-nav-closed'}`}>
            <SectionNav section="team" />
            {!appContext.selectedOrganisation.published && <UnpublishedOrgBanner />}
            <ErrorBoundary>
                <div
                    className={`section-content section-content-no-bottom-pad ${
                        !appContext.selectedOrganisation.published && 'section-content-with-banner'
                    }`}
                >
                    <Route path="/team/team-members">
                        <TeamMembers selectedOrganisation={appContext.selectedOrganisation} />
                    </Route>
                </div>
            </ErrorBoundary>
        </div>
    );
}
